import { store } from "..";

export const reduxState = () => {
    return store.getState
}

export const reduxDispatch = () => {
    return store.dispatch
}